import { useEffect } from "react";
import pages from "./pages.json";
import "./MayowaPage.css";

const PAGE_FILES = new Map(pages.map(({ route, file }) => [route, file]));

export default function MayowaPage({ path = "/" }) {
  const file = PAGE_FILES.get(path);
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Mayowa Fadeni | Web Apps & Software Engineering";
    if (/^\/mayowa(?:\/|$)/.test(window.location.pathname)) {
      window.history.replaceState(window.history.state, "", path + window.location.search + window.location.hash);
    }
    return () => { document.title = previousTitle; };
  }, [path]);

  if (!file) {
    return (
      <main className="mayowa-not-found">
        <h1>Page not found</h1>
        <a href="/">Back to the homepage</a>
      </main>
    );
  }

  return (
    <main className="mayowa-page">
      <iframe
        className="mayowa-page__frame"
        src={`/mayowa-assets/${file}${window.location.hash}`}
        title="Mayowa Fadeni portfolio"
        onLoad={(event) => {
          const title = event.currentTarget.contentDocument?.title;
          if (title) document.title = title;
        }}
      />
    </main>
  );
}
